// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"bcad1a56","323":"ba553b56","568":"95bf8ba8","750":"2c39b440","996":"78501307"}[chunkId] + ".chunk.js";
};